import React, { useMemo, useState } from "react";
import {
  Box,
  Popover,
  IconButton,
  Typography,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const YEAR_RANGE = 12;

const YearPickerPopup = ({ value, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const currentYear = new Date().getFullYear();

  const [startYear, setStartYear] = useState(
    Math.floor(value / YEAR_RANGE) * YEAR_RANGE
  );

  const years = useMemo(() => {
    return Array.from({ length: YEAR_RANGE }, (_, i) => startYear + i);
  }, [startYear]);

  const open = Boolean(anchorEl);

  return (
    <>
      {/* Trigger */}
      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          cursor: "pointer",
          px: 2,
          border: "1px solid #E5E7EB",
          borderRadius: "8px",
          height: "40px",

          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // hoặc "center"
          gap: 1,
        }}
      >
        {value}
        <KeyboardArrowDownIcon fontSize="small" />
      </Box>

      {/* Popup */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ width: 320, p: 2 }}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <IconButton
              size="small"
              onClick={() => setStartYear((prev) => prev - YEAR_RANGE)}
            >
              <ChevronLeftIcon />
            </IconButton>

            <Typography fontWeight={600}>
              {startYear} - {startYear + YEAR_RANGE - 1}
            </Typography>

            <IconButton
              size="small"
              onClick={() => setStartYear((prev) => prev + YEAR_RANGE)}
            >
              <ChevronRightIcon />
            </IconButton>
          </Box>

          {/* Year grid */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 1.5,
            }}
          >
            {years.map((year) => {
              const selected = year === value;

              return (
                <Box
                  key={year}
                  onClick={() => {
                    onChange(year);
                    setAnchorEl(null);
                  }}
                  sx={{
                    py: 1.5,
                    textAlign: "center",
                    borderRadius: 2,
                    cursor: "pointer",
                    border: selected
                      ? "2px solid #2563EB"
                      : "1px solid transparent",
                    backgroundColor: selected ? "#EFF6FF" : "transparent",
                    fontWeight: selected ? 600 : 400,
                    "&:hover": {
                      backgroundColor: "#F3F4F6",
                    },
                  }}
                >
                  {year}
                </Box>
              );
            })}
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default YearPickerPopup;
